import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import I18n from "redux-i18n";
import { translations } from './translations';
import { getStoredLanguage } from './helpers/language';

import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <I18n translations={translations} initialLang={getStoredLanguage()}>
      <App />
    </I18n>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
